<template>
    <v-row no-gutters>

        <v-col cols="12" xs="12" md="12">
            <v-data-table
                :loading="loading"
                :headers="headers"
                :items="entities"
                :item-class="itemRowBackground"
                :options.sync="options"
                :server-items-length="total"
                :items-per-page="10"
                :footer-props="{ itemsPerPageOptions:[5, 10, 20] }"
                :page.sync="options.page"
                @page-count="paginationPageCount = $event"
                class="elevation-1 customization-list-table pagination-list-table sticky-table"
                @dblclick:row="(event, data) => $eventBus.$emit('open-document', { id: data.item.task_id, type: 'Documents|Orders|CitizenStatements.ResolutionTask', common: data.item.iscommon })">
                <v-progress-linear slot="progress" height="2" color="#E43958" indeterminate></v-progress-linear>

                <template v-slot:[`item.theme`]="{ item }">
                    <div class="elipsis-text-wrap">
                        <v-doc-type-chip v-if="item.issubstitution" :type="'Substitution'" :text="$t('Замещение')"/>
                        <v-common-chip v-if="item.iscommon === true && item.isown === false" :document-type="item.doctypeof"/>
                        <v-doc-type-chip :type="'Resolution'" :text="$t('Резолюция')"/>
                        <div class="etw-text-container">
                            <div class="etw-text" v-tooltip.top-center="item.theme">
                                {{item.theme}}
                            </div>
                        </div>
                    </div>
                </template>

                <template v-slot:[`item.authorname`]="{ item }">
                    <v-employee-chip v-if="item.authorname" :id="item.authorid" :name="item.authorname" />
                </template>
                
                <template v-slot:[`item.executers`]="{ item }">
                    <template v-for="(executer) in item.executers">
                        <v-workplace-chip :key="executer.ID" :id="executer.ID" :name="executer.Name" :iconColor="executerStatusColor(executer)" />
                    </template> 
                </template>

                <template v-slot:[`item.createdate`]="{ item }">
                    {{ formatDate(item.createdate) }}
                </template>

                <template v-slot:[`item.currentlimit`]="{ item }">
                    {{ formatDate(item.currentlimit) }}
                </template>

                <template v-slot:[`item.controldays`]="{ item }">
                    <StatusChip :status="avaibleStatuses[$helpers.getTaskStatus(item.workstatus)]"/>
                </template>

                <template v-slot:[`footer.prepend`]>
                    <v-pagination
                        v-model="options.page"
                        :length="paginationPageCount"
                        :total-visible="$listPaginationTotal"
                        color="teal"
                    ></v-pagination>
                </template>

            </v-data-table>
        </v-col>

    </v-row>

</template>

<script>
import i18n from '@/i18n'
import Axios from 'axios';
import { httpAPI } from "@/api/httpAPI";
import { mapActions } from 'vuex';
import StatusChip from '@/components/StatusChip';

export default {
    columnIndex:  {
        'theme': 6,
        'regnumber': 12,
        'createdate': 32,
        'currentlimit': 5,
    },
    props: {
        status: {
            type: String,
            default: null
        },
        search: {
            type: String,
            default: ""
        }
    },
    components: {
        StatusChip
    },
    data () {
        return {
            loading: true,
            cancellationTokenSorce: null,
            total: 0,            
            entities: [],
            prevTableFilterObject: null,
            paginationPageCount: 0,
        }
    },
    computed: {
        headers() {
            let headers =  [
                { text: i18n.t("Номер"), value: 'regnumber', width: '150px' },
                { text: i18n.t("Дата_создания"), value: 'createdate', width: '150px' },
                { text: i18n.t("Краткое_содержание"), value: 'theme' },
                { text: i18n.t('Исполнители'), value: 'executers', sortable: false },
                { text: i18n.t("Срок"), value: 'currentlimit', width: '150px' },
            ];
            //if (this.filter.ReportStatus == 'All')
                headers.push({ text: i18n.t("Статус"), value: 'controldays', sortable: false, width: '120px' });
            return headers;
        },
        options: {
            get: function() {
                return this.$store.getters['reportsgeneration/mycreated/GetTableOptions'];
            },
            set: function(newValue) {
                this.$store.commit('reportsgeneration/mycreated/SET_TABLE_OPTION', newValue);
            }
        },
        collection () {
            return this.$store.getters['reportsgeneration/getCollection'];
        },
        filter () {
            return {
                ...this.options,
                SearchStr: this.search,
                ReportStatus: this.status
            }
        },
        avaibleStatuses() {
            return this.$store.getters['references/GetAvaibleStatuses'];
        }
    },
    methods: {
        ...mapActions(['setOverlayVisible']),
        resetPage() {
            this.$store.commit('reportsgeneration/mycreated/SET_TABLE_OPTION_PAGE', 1);
        },
        itemRowBackground (item) {
            return item.readed ? '' : 'font-weight-bold';
        },        
        async getData(isRefresh = false) {
            if (isRefresh === false && this.$_.isEqual(this.prevTableFilterObject, this.getTableFilterObject()))
                return;
            this.setOverlayVisible({ visible: true });    
            this.prevTableFilterObject = this.getTableFilterObject();
            this.total = 0;
            this.entities = [];
            this.loading = true;

            if (this.cancellationTokenSorce)
                this.cancellationTokenSorce.cancel('New request started');

            this.cancellationTokenSorce = Axios.CancelToken.source();

            let response = await httpAPI({
                url: `/api/report/list?collection=${this.collection}&filter=${this.getTableFilterObject()}`,
                method: 'GET',
                cancelToken: this.cancellationTokenSorce.token,
            });

            this.entities = response?.data?.payload?.data ?? [];
            this.total = response?.data?.payload?.total ?? 0;

            this.loading = false;
            this.setOverlayVisible({ visible: false });
        },
        getTableFilterObject() {
            let { sortBy, sortDesc, page, itemsPerPage, SearchStr, ReportStatus } = this.filter;
            let OrderDir = sortDesc.length <= 0 ? false : sortDesc[0];
            let sortColumn = sortBy.length <= 0 ? "createdate" : sortBy[0];
            let OrderBy = this.$options.columnIndex[sortColumn] ?? 3;

            return JSON.stringify({ ReportStatus, SearchStr, OrderBy, OrderDir, Limit: itemsPerPage, Offset: (page - 1) * itemsPerPage });
        },
        formatDate (value) {
            if (!value)
                return '';

            return this.$moment(value).format('DD.MM.YYYY');
        },
        executerStatusColor(item) {
            switch(item.Status)
            {
                case 3:
                case 16:
                    return "#43B581";
                
                case 2:
                    return "#FAA61A";

                case 5:
                    return "#F04747";

                default:
                    return null;
            }
        }
    },
    watch: {
        filter: {
            handler () {
                this.getData()
            },
            deep: true,
        },
    },
}
</script>